import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";
import { Button, Combobox, Form, FormControl, FormField, FormItem, FormLabel, FormMessage, Input, Label, RadioGroup, RadioGroupItem } from "@saridana-core/react-ui-kit";
import { TProduct } from "@shared/types";
import { PottedPlantIcon } from "@shared/ui/custom-icon";
import { formatCurrency } from "@shared/utils";
import { useState } from "react";
import { useIMask } from "react-imask";
import z from "zod";
import { calculateTotalRate, calculateTotalSum } from "../lib";
import { CalculatorResult } from "../types";
function DetailItem(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <div className="flex-1">{label}</div>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <div className="font-semibold">{value}</div>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex justify-between text-base sm:text-lg w-full">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function CalculatedRateCalculatorForm(t0) {
  const $ = _c(74);
  const {
    product
  } = t0;
  const {
    calculatedRate,
    min,
    max,
    calculatorType
  } = product;
  let t1;
  let t2;
  if ($[0] !== calculatedRate?.isShowAnnualInterest) {
    const formSchema = z.object({
      amount: z.string(),
      month: z.int({
        error: _temp
      }),
      percent: calculatedRate?.isShowAnnualInterest ? z.number({
        error: _temp2
      }) : z.number({
        error: _temp3
      }).optional()
    });
    t2 = useForm;
    t1 = zodResolver(formSchema);
    $[0] = calculatedRate?.isShowAnnualInterest;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== calculatedRate?.defaultAmount || $[4] !== min) {
    t3 = calculatedRate?.defaultAmount?.toString() || min?.toString() || "0";
    $[3] = calculatedRate?.defaultAmount;
    $[4] = min;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = calculatedRate?.defaultMonth || 12;
  let t5;
  if ($[6] !== calculatedRate) {
    t5 = calculatedRate?.months && calculatedRate?.defaultMonth && calculatedRate.isShowAnnualInterest ? calculatedRate?.months?.find(it => it.monthCount === calculatedRate?.defaultMonth)?.percent : undefined;
    $[6] = calculatedRate;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      amount: t3,
      month: t4,
      percent: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = {
      resolver: t1,
      defaultValues: t6
    };
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const form = t2(t7);
  let t8;
  if ($[15] !== max || $[16] !== min) {
    t8 = {
      mask: Number,
      min,
      max,
      thousandsSeparator: "."
    };
    $[15] = max;
    $[16] = min;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const {
    ref: amountMaskRef,
    unmaskedValue
  } = useIMask(t8);
  const [result, setResult] = useState(null);
  let t9;
  if ($[18] !== calculatedRate?.taxAmount) {
    t9 = payload => {
      if (payload) {
        const amountWithoutTax = calculateTotalRate(payload.amount, payload.percent, payload.month);
        const amountWithTax = calculateTotalRate(payload.amount, payload.percent, payload.month, calculatedRate?.taxAmount || 0);
        setResult({
          amount: calculateTotalSum(payload.amount, payload.percent, payload.month, calculatedRate?.taxAmount || 0),
          amountWithoutTax,
          amountWithTax,
          rate: amountWithoutTax - amountWithTax
        });
      }
    };
    $[18] = calculatedRate?.taxAmount;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const handleSubmit = t9;
  let t10;
  if ($[20] !== calculatedRate?.months) {
    t10 = calculatedRate?.months.map(_temp4) || [];
    $[20] = calculatedRate?.months;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const comboboxOptions = t10;
  if (!calculatedRate || calculatorType !== "calculatedRate") {
    return null;
  }
  let t11;
  if ($[22] !== form || $[23] !== handleSubmit) {
    t11 = form.handleSubmit(handleSubmit);
    $[22] = form;
    $[23] = handleSubmit;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== amountMaskRef || $[26] !== calculatedRate.amountInputLabel || $[27] !== calculatedRate.amountInputPlaceholder || $[28] !== calculatedRate.currency || $[29] !== form || $[30] !== unmaskedValue) {
    t12 = t13 => {
      const {
        field
      } = t13;
      return <FormItem>{calculatedRate.amountInputLabel && <FormLabel className="text-lg mb-2 inline-block">{calculatedRate.amountInputLabel}</FormLabel>}<FormControl><div className="inline-flex w-full relative"><span className="absolute top-[50%] left-4 text-lg md:text-xl text-gray-500 transform translate-y-[-50%]">{calculatedRate.currency}</span><Input className="!p-4 min-h-[50px] md:min-h-[60px] text-lg md:!text-xl !pl-12" type="tel" inputMode="numeric" placeholder={calculatedRate.amountInputPlaceholder || ""} defaultValue={field.value} ref={amountMaskRef as any} onInput={() => {
              form.resetField("amount", {
                defaultValue: unmaskedValue ? unmaskedValue : undefined
              });
            }} /></div></FormControl><FormMessage className="text-sm md:text-base inline-block mt-2" /></FormItem>;
    };
    $[25] = amountMaskRef;
    $[26] = calculatedRate.amountInputLabel;
    $[27] = calculatedRate.amountInputPlaceholder;
    $[28] = calculatedRate.currency;
    $[29] = form;
    $[30] = unmaskedValue;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== form.control || $[33] !== t12) {
    t13 = <FormField control={form.control} name="amount" render={t12} />;
    $[32] = form.control;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== calculatedRate.monthInputLabel || $[36] !== calculatedRate.monthInputType || $[37] !== calculatedRate.months || $[38] !== comboboxOptions || $[39] !== form) {
    t14 = t15 => {
      const {
        field: field_0
      } = t15;
      return <FormItem>{calculatedRate.monthInputLabel && <FormLabel className="text-lg mb-2 inline-block">{calculatedRate.monthInputLabel}</FormLabel>}<FormControl>{calculatedRate.monthInputType === "radio" ? <div><RadioGroup defaultValue={field_0.value?.toString()} onValueChange={val => {
              form.resetField("month", {
                defaultValue: parseInt(val)
              });
              form.resetField("percent", {
                defaultValue: calculatedRate.months.find(it_1 => it_1.monthCount === parseInt(val))?.percent
              });
            }} className="space-y-2">{calculatedRate.months.map(_temp5)}</RadioGroup></div> : calculatedRate.monthInputType === "select" && <div><Combobox initialValue={field_0.value ? comboboxOptions.find(it_2 => it_2.value === field_0.value) : null} options={comboboxOptions} onChange={val_0 => {
              form.resetField("month", {
                defaultValue: val_0.value
              });
              form.resetField("percent", {
                defaultValue: calculatedRate.months.find(it_3 => it_3.monthCount === parseInt(val_0.value))?.percent
              });
            }} buttonProps={{
              className: "w-full !p-4 min-h-[50px] md:min-h-[60px] text-lg md:!text-xl"
            }} inputProps={{
              placeholder: "Pilih tenor deposito",
              className: "text-lg md:!text-xl"
            }} appendIcon={<ChevronDownIcon className="size-5" />} /></div>}</FormControl><FormMessage className="text-sm md:text-base inline-block mt-2" /></FormItem>;
    };
    $[35] = calculatedRate.monthInputLabel;
    $[36] = calculatedRate.monthInputType;
    $[37] = calculatedRate.months;
    $[38] = comboboxOptions;
    $[39] = form;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== form.control || $[42] !== t14) {
    t15 = <FormField control={form.control} name="month" render={t14} />;
    $[41] = form.control;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== calculatedRate.annualInterestInputLabel || $[45] !== calculatedRate.annualInterestInputPlaceholder || $[46] !== calculatedRate.isShowAnnualInterest || $[47] !== form) {
    t16 = calculatedRate.isShowAnnualInterest && <FormField control={form.control} name="percent" render={t17 => {
      const {
        field: field_1
      } = t17;
      return <FormItem>{calculatedRate.annualInterestInputLabel && <FormLabel className="text-lg mb-2 inline-block">{calculatedRate.annualInterestInputLabel}</FormLabel>}<FormControl><div className="inline-flex w-full relative"><span className="absolute top-[50%] left-4 text-lg md:text-xl  transform translate-y-[-50%]"><PottedPlantIcon className="size-7 text-[#0DABAB]" /></span><Input className="!p-4 min-h-[50px] md:min-h-[60px] text-lg md:!text-xl !pl-14 !pr-12" type="number" inputMode="decimal" max={100} min={0} step={0.25} maxLength={3} placeholder={calculatedRate.annualInterestInputPlaceholder || ""} defaultValue={field_1.value} onChange={event => {
              form.resetField("percent", {
                defaultValue: event.target.value && event.target.value !== "" ? parseFloat(event.target.value) : 0
              });
            }} /><span className="absolute top-[50%] right-4 text-lg md:text-xl text-gray-500 transform translate-y-[-50%]">%</span></div></FormControl><FormMessage className="text-sm md:text-base inline-block mt-2" /></FormItem>;
    }} />;
    $[44] = calculatedRate.annualInterestInputLabel;
    $[45] = calculatedRate.annualInterestInputPlaceholder;
    $[46] = calculatedRate.isShowAnnualInterest;
    $[47] = form;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  const t17 = calculatedRate.buttonText || "Hitung";
  let t18;
  if ($[49] !== t17) {
    t18 = <Button type="submit" className="text-lg md:text-xl h-14 md:h-[60px] md:px-8 w-full rounded-xl py-4 px-6 font-bold">{t17}</Button>;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t11 || $[52] !== t13 || $[53] !== t15 || $[54] !== t16 || $[55] !== t18) {
    t19 = <form onSubmit={t11} className="space-y-7">{t13}{t15}{t16}{t18}</form>;
    $[51] = t11;
    $[52] = t13;
    $[53] = t15;
    $[54] = t16;
    $[55] = t18;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== form || $[58] !== t19) {
    t20 = <Form {...form}>{t19}</Form>;
    $[57] = form;
    $[58] = t19;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== calculatedRate.rateAfterTaxLabel || $[61] !== calculatedRate.rateBeforeTaxLabel || $[62] !== calculatedRate.taxAmount || $[63] !== calculatedRate.taxAmountLabel || $[64] !== calculatedRate.totalSumLabel || $[65] !== calculatedRate.totalSumNote || $[66] !== result) {
    t21 = result && <><div className="mt-6">{calculatedRate.totalSumLabel && result.amount && <div className="bg-[#F0FDFB] text-center space-y-3 rounded-xl py-5 px-4"><div className="text-lg sm:text-xl font-medium text-gray-900">{calculatedRate.totalSumLabel}</div><div><h4 className="text-[28px] sm:text-[32px] text-[#0DABAB] font-bold leading-[130%]">{formatCurrency(result.amount)}</h4>{calculatedRate.totalSumNote && <div className="text-base font-normal text-gray-600 leading-[150%] mt-1 italic">{calculatedRate.totalSumNote}</div>}</div></div>}</div>{(calculatedRate.rateBeforeTaxLabel || calculatedRate.rateAfterTaxLabel || calculatedRate.taxAmountLabel) && <><div className="space-y-2 mt-5">{calculatedRate.rateBeforeTaxLabel && result.amountWithoutTax && <DetailItem value={formatCurrency(result.amountWithoutTax)} label={calculatedRate.rateBeforeTaxLabel} />}{calculatedRate.taxAmountLabel && calculatedRate.taxAmount && result.rate && <DetailItem value={formatCurrency(result.rate)} label={calculatedRate.taxAmountLabel} />}{calculatedRate.rateAfterTaxLabel && result.amountWithTax && <DetailItem value={formatCurrency(result.amountWithTax)} label={calculatedRate.rateAfterTaxLabel} />}</div><hr className="border-dashed border-gray-200 mb-1 mt-5 bg-transparent" /></>}</>;
    $[60] = calculatedRate.rateAfterTaxLabel;
    $[61] = calculatedRate.rateBeforeTaxLabel;
    $[62] = calculatedRate.taxAmount;
    $[63] = calculatedRate.taxAmountLabel;
    $[64] = calculatedRate.totalSumLabel;
    $[65] = calculatedRate.totalSumNote;
    $[66] = result;
    $[67] = t21;
  } else {
    t21 = $[67];
  }
  let t22;
  if ($[68] !== calculatedRate.agreementText) {
    t22 = calculatedRate.agreementText && <div className="text-base font-normal text-gray-500 mt-4">{calculatedRate.agreementText}</div>;
    $[68] = calculatedRate.agreementText;
    $[69] = t22;
  } else {
    t22 = $[69];
  }
  let t23;
  if ($[70] !== t20 || $[71] !== t21 || $[72] !== t22) {
    t23 = <>{t20}{t21}{t22}</>;
    $[70] = t20;
    $[71] = t21;
    $[72] = t22;
    $[73] = t23;
  } else {
    t23 = $[73];
  }
  return t23;
}
function _temp5(month) {
  return <div className="flex items-center gap-3" key={"month-option-" + month.monthCount}><RadioGroupItem id={"month-option-" + month.monthCount} value={month.monthCount.toString()} /><Label htmlFor={"month-option-" + month.monthCount}>{month.title}</Label></div>;
}
function _temp4(it_0) {
  return {
    value: it_0.monthCount,
    label: it_0.title
  };
}
function _temp3(t0) {
  const {
    input: input_1
  } = t0;
  if (input_1 === undefined) {
    return "Harus diisi";
  }
}
function _temp2(t0) {
  const {
    input: input_0
  } = t0;
  if (input_0 === undefined) {
    return "Harus diisi";
  }
}
function _temp(t0) {
  const {
    input
  } = t0;
  if (input === undefined) {
    return "Pilih salah satu";
  }
}